var _radialGradient, _path, _path2, _path3, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient, _radialGradient5, _path4, _path5, _path6, _path7, _radialGradient6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaLotto6From45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 32.761,
    cy: 22.525,
    r: 60.147,
    gradientTransform: "matrix(.5522 .8337 -1.1845 .7845 41.352 -22.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fffbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#fff5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#fff1a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#ffef91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#ffee8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#ffec80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#fee45f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#fedf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fedc39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#fedb34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#f1c12d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#df9e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#d1841d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c77219"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.01 3.26c22.91 0 41.48 18.69 41.48 41.74S66.92 86.73 44.01 86.73C21.1 86.74 2.53 68.05 2.53 45S21.1 3.26 44.01 3.26z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 59.71s5.65 13 19.5 17.53C47.3 81.76 60 78.86 60 78.86s-11.43 9.41-29.88 3.25c-18.46-6.15-19.52-16.4-19.52-16.4s.93-9.26 3.35-6z",
    opacity: 0.3,
    fill: "#dc972f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.73 54s3.96-3.12 7.54-6.6 5.3-6.97 5.3-6.97 1.32 17.45-9.34 29.14C64.56 81.26 56.64 80.93 56.64 80.93S76.14 71.4 71.73 54z",
    fill: "#d99421"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 52.697,
    cy: 82.48,
    r: 2.79,
    gradientTransform: "matrix(.9174 -.398 .3072 .708 -20.981 45.064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#fedb34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#efbe2c",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df9e24",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.91 80.78c1.23-.58 2.59-.29 3.03.64.44.94-.21 2.17-1.44 2.75-1.24.58-2.59.3-3.03-.64s.2-2.16 1.44-2.75z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 58.357,
    cy: 80.245,
    r: 1.46,
    gradientTransform: "matrix(.8069 -.5908 .492 .672 -28.21 60.796)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#fedb34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#efbe2c",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df9e24",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.94 79.27c.61-.27 1.3-.04 1.53.49.23.54-.07 1.2-.69 1.46-.62.27-1.3.05-1.54-.49-.23-.54.08-1.2.7-1.46z",
    fill: "url(#c)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 14.383,
    cy: 64.132,
    r: 4.051,
    gradientTransform: "matrix(.9173 -.3983 .5783 1.332 -35.899 -15.562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#fedb34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#efbe2c",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df9e24",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 59c1.73-.68 4.08 1.21 5.26 4.23s.73 6.02-1 6.7c-1.73.69-4.09-1.21-5.27-4.23-1.17-3.01-.72-6.01 1.01-6.7z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 2.306,
    y1: 13.213,
    x2: 26.046,
    y2: 54.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#ffee8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#fee254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#fedb34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d035"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.13 14.85s-9.46 5.69-12.58 16.6C3.44 42.36 5.17 46.08 5.17 46.08l4.62 5.46s-5.26-19.38 9.34-36.69z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 7.833,
    cy: 47.753,
    r: 5.348,
    gradientTransform: "matrix(1 0 0 1.695 0 -33.187)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ffee8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#fee254",
    stopOpacity: 0.401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedb34",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83 39.56c2.74 0 4.96 3.67 4.96 8.19s-2.22 8.19-4.96 8.19-4.96-3.66-4.96-8.19 2.23-8.19 4.96-8.19z",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.27 30.45c-1.46-1.66-3.72-2.61-6.21-2.61-1.36 0-2.77.32-4.05.91-.63-.52-1.39-.87-2.22-.87h-7.64c-.32 0-.62.09-.92.17-.26-.06-.51-.17-.78-.17H42.8c-.88 0-1.68.33-2.31.86-1.16-.56-2.47-.9-3.88-.9-2.8 0-5.75 1.29-7.5 3.73.03-.9-.23-1.79-.83-2.48a3.566 3.566 0 0 0-2.68-1.21h-3.06c-1.8 0-3.31 1.33-3.54 3.11L17.5 42.6c-.13 1.02.18 2.04.86 2.81.4.45.91.74 1.46.95-1.84 1.64-3.21 3.96-3.5 6.95l-.54 5.72c-.35 3.68 1.04 6.06 2.27 7.41 1.75 1.93 4.38 3.03 7.21 3.03l.38-.01c1.78-.06 3.45-.58 4.93-1.41.53.3 1.13.48 1.76.48h1.8c1.63 0 3.05-1.1 3.46-2.68l.22-.85c.33.1.66.21 1.02.21h4.33a3.62 3.62 0 0 0 .94 2.17c.68.73 1.62 1.14 2.62 1.14h4.03c1.33 0 2.47-.75 3.09-1.84l.16.21c.99 1.08 2.82 2.37 5.89 2.37h2.49c4.56 0 8.41-3.45 8.76-7.84l.32-3.95c.11-1.35-.12-2.65-.66-3.81.65-.59 1.08-1.42 1.16-2.36l.26-3.26a3.58 3.58 0 0 0-.94-2.71c-.25-.27-.57-.45-.89-.63 1.63-1.25 2.86-3.09 3.17-5.5l.39-3.01c.26-2.16-.33-4.21-1.68-5.74zM42.02 48.61c.23-.88.09-1.8-.35-2.59.56.36 1.18.61 1.87.61h.1l-1.62 1.98z",
    fill: "#2a721e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.04 43.06h7.9l.34-2.61h-4.85l1.16-9h-3.06l-1.49 11.61zm19.51-4.3.39-3.01c.75-5.79-9.02-5.79-9.77 0l-.39 3.01c-.75 5.79 9.02 5.79 9.77 0zm-3.18.18.44-3.37c.3-2.3-3.17-2.3-3.47 0l-.44 3.37c-.29 2.31 3.17 2.31 3.47 0zm32.62-.18.39-3.01c.75-5.79-9.03-5.79-9.77 0l-.39 3.01c-.75 5.79 9.03 5.79 9.77 0zm-3.17.18.44-3.37c.3-2.3-3.17-2.3-3.47 0l-.44 3.37c-.3 2.31 3.17 2.31 3.47 0zm-24.36-4.88h2.25l-1.17 9h3.06l1.16-9h2.34l.34-2.62H42.8zm9.34 0h2.25l-1.16 9h3.06l1.16-9h2.34l.33-2.62h-7.64zm4.67 13.71h12.16l-.26 3.26H59.6l-.21 2.68c2.01-2.28 8.86-1.24 8.48 3.49l-.32 3.95c-.2 2.51-2.54 4.56-5.21 4.56h-2.49c-3.73 0-4.62-2.78-4.38-5.73h3.21c-.15 1.93.94 2.45 2.73 2.45 3.3 0 2.99-2.12 3.17-4.35.09-1.18-.86-2.15-2.11-2.15-1.34 0-3.25-.2-3.64 1.67h-3.17l.81-9.83zm-4.44-.07-.8 10.6h2.45l-.25 3.37h-2.45l-.25 3.31H46.7l.25-3.31h-8.13l.28-3.81 8.29-10.15 4.64-.01zm-9.25 10.59h4.42l.45-5.97-4.87 5.97zm-19.47.19c2.24-2.33 5.43-1.5 5.16 1.42-.34 3.53-5.63 3.53-5.29 0l.13-1.42zm.26-2.66.26-2.71c.29-3.08 4.73-3.69 5.27-.7h3.88c-.75-7.78-12.34-6.71-13.09 1.24l-.55 5.72c-.43 4.47 2.81 6.65 6.18 6.53 3.58-.13 6.39-2.77 6.84-5.8.71-5.01-5.1-7.93-8.79-4.28zm8.74 9.15h1.8l4.46-17.25h-1.8z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m28.71 15.46.74 1.98 2.06.12-1.6 1.34.53 2.06-1.73-1.16-1.73 1.16.53-2.06-1.6-1.34 2.05-.12zm6.46-5.87.74 1.99 2.06.11-1.6 1.35.53 2.05-1.73-1.15-1.73 1.15.53-2.05-1.6-1.35 2.06-.11zm8.11-1.68.74 1.99 2.05.11-1.59 1.34.53 2.06-1.73-1.15-1.74 1.15.53-2.06-1.59-1.34 2.06-.11zm6.48 1.74.75 1.99 2.06.11-1.6 1.35.53 2.05L49.76 14l-1.72 1.15.53-2.05-1.6-1.35 2.05-.11zm6.61 5.63.74 1.99 2.06.11-1.6 1.35.54 2.06-1.74-1.16-1.73 1.16.53-2.06-1.6-1.35 2.06-.11zm3.2 7.35.75 1.98 2.05.12-1.59 1.34.52 2.06-1.73-1.16-1.73 1.16.53-2.06-1.6-1.34 2.06-.12zm-32.59.17.74 1.99 2.06.11-1.6 1.35.53 2.05-1.73-1.16-1.74 1.16.54-2.05-1.6-1.35 2.06-.11z",
    fill: "#29721d"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 42.321,
    cy: 20.708,
    r: 8.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#42ad8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#29721d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#266a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#215816"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.04 21.54c1.64.12 3.26.28 5.02-.09.32-1.45.36-3.08.15-4.88.95.1 3.93 2.73 3.98 4.11.45.25 3.22.03 4.06-.39-.26 1.45-1.18 2.83-2.39 3.45.17 1.74.51 3.48.02 5.47-.62-1.32-1.3-2.41-2.21-3.5-.62 1.1-4.43 3.74-6.55 4 1.38-1.72 2.35-4.84 2.1-5.63-1.67-.2-3.87-1.77-4.18-2.54z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaLotto6From45);
export default __webpack_public_path__ + "static/media/australia_lotto_6_from_45.7d0fcd897495ba769b266006af76e87a.svg";
export { ForwardRef as ReactComponent };